// This folder and index file were auto-generated and included in theme.js by the infinite cli
// Add the various components for your JS inside this folder and import them (or npm modules) like this:
import { debounce } from '../../utils/lodash-replacements';
import { standardizeHeights } from '../../core/INF-gridAlignment';
import { initPodsCarousels } from '../../sections/INF-Pods/carousel';

export default function () {
  if (document.querySelectorAll('[data-section-type="INF-Pods"]').length === 0) {
    return;
  }

  const grid_item_selector = '[data-podsabovebelow-slide]';
  const child_selectors = ['[data-podsabovebelow-slide-title]'];
  standardizeHeights(grid_item_selector, child_selectors);
  initPodsCarousels();

  const resizeHandler = debounce(() => {
    standardizeHeights(grid_item_selector, child_selectors);
  }, 500);

  window.addEventListener('resize', resizeHandler);
}
